
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.3 141.3"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-881.217","y1":"1024.717","x2":"-881.217","y2":"1025.717","gradientTransform":"matrix(141.333 0 0 -141.333 124615.695 144967.64)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#5982df"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#54aacd"}})]),_c('path',{attrs:{"d":"M17.3 0C7.8 0 0 7.8 0 17.3V124c0 9.6 7.8 17.3 17.3 17.3H124c9.6 0 17.3-7.8 17.3-17.3V17.3C141.3 7.8 133.6 0 124 0H17.3z","fill":"url(#a)"}}),_c('path',{attrs:{"d":"M123 38.2c-3.8 1.7-8 2.9-12.3 3.4 4.4-2.7 7.8-6.9 9.4-11.9-4.1 2.5-8.7 4.2-13.6 5.2-3.9-4.2-9.5-6.8-15.7-6.8-11.9 0-21.5 9.6-21.5 21.5 0 1.7.2 3.3.6 4.9-17.9-.9-33.7-9.4-44.3-22.4-1.8 3.2-2.9 6.9-2.9 10.8 0 7.4 3.8 14 9.5 17.9-3.5-.1-6.8-1.1-9.7-2.7v.3c0 10.4 7.4 19.1 17.2 21-1.8.5-3.7.8-5.7.8-1.4 0-2.7-.1-4-.4 2.7 8.5 10.7 14.7 20.1 14.9-7.3 5.8-16.6 9.2-26.7 9.2-1.7 0-3.4-.1-5.1-.3 9.5 6.1 20.8 9.6 32.9 9.6 39.5 0 61.1-32.7 61.1-61.1 0-.9 0-1.9-.1-2.8 4.3-3 7.9-6.8 10.8-11.1z","fill":"#fff"}})])
          )
        }
      }
    